<!-- TrustBox widget - Micro Combo -->
<div
  id="trustbox-header-widget"
  class="trustpilot-widget"
  data-locale="en-GB"
  data-template-id="5419b6ffb0d04a076446a9af"
  data-businessunit-id="5eef185e72777600019676aa"
  data-style-height="20px"
  data-style-width="100%">
    <a 
      href="https://uk.trustpilot.com/review/www.identibase.co.uk"
      target="_blank"
      rel="noopener">
      Trustpilot
    </a>
</div>
<!-- End TrustBox widget -->
